import { createSlice } from '@reduxjs/toolkit';

export const customCounsellingThreeSlice = createSlice({
  name: 'customCounsellingThree',
  initialState: {
    allDataThree: null,
  },
  reducers: {
    setAllDataThree: (state, action) => {
      state.allDataThree = action.payload;
    },
  },
});

export const { setAllDataThree } = customCounsellingThreeSlice.actions;
export default customCounsellingThreeSlice.reducer;
